import axios from "axios";

const Url = process.env.REACT_APP_URl;

// AI listing creation

export const AiListingsCreationServ = async (obj: any) => {
    const response = await axios.post(Url + "/upload_images_selective_analysis", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const analyzeSingleImage = async (processId: any, idImage: string | number) => {
    const response = await axios.post(Url + "/analyze_single_image/" + processId + "/" + idImage, {}, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const ProcessAllImageServ = async (obj: any) => {
    const response = await axios.post(Url + "/ProcessAllimage", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const EnhanceImageMultiple = async (obj: any) => {
    const response = await axios.post(Url + "/enhance_image_multiple", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const UndoServ = async (obj: any) => {
    const response = await axios.post(Url + "/undo", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const RedoServ = async (obj: any) => {
    const response = await axios.post(Url + "/redo", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const ResetServ = async (obj: any) => {
    const response = await axios.post(Url + "/reset", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const AddImageServ = async (id: string, obj: any) => {
    const response = await axios.post(Url + "/upload_additional_images/" + id, { images: obj }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const AddImageEnhanceServ = async (obj: any) => {
    const response = await axios.post(Url + "/upload_single_image_enhance_generate", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const RemoveImageServ = async (obj: any) => {
    const response = await axios.post(Url + "/remove_single_image", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const OrderImagesServ = async (obj: any) => {
    const response = await axios.post(Url + "/order_images", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetCredits = async () => {
    const response = await axios.get(Url + "/Getcredits", {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const DownoladXmlOne = async (obj: any) => {
    const response = await axios.post(Url + "/downloadxmlforone", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
